export default __webpack_public_path__ + "static/media/10、900ml常温果汁.e28ffcd2.jpg";